import { characterClassesByGameVersion } from 'app/frontend/types/custom/CharacterClass'
import { usePageInfo } from 'app/frontend/base/config/queries'

export const useCharacterClasses = () => {
  const {
    data: { gameVersion },
  } = usePageInfo()
  return characterClassesByGameVersion[gameVersion]
}
